import React, { useState, useEffect, useCallback, useRef } from "react";
import { UserResponseModel } from "../../swagger-clients/s365-dashboard-v2-api-clients.service";
import { getUsersClient } from "../../services/dashboard.service";
import { processServerError } from "../../utils/helpers/error.helper";
import { useIsAuthenticated } from "@azure/msal-react";
import { ConfirmEmailDialog } from "./confirm-email-dialog";
import { addMinutes } from "../../utils/helpers/date.helpers";


type ConfirmEmailProps = {
    onConfirmEmailStatusChange: (isConfirmed: boolean, expiryDate?: Date) => void;
}

export const ConfirmEmail: React.FC<ConfirmEmailProps> = (props) => {
    const [user, setUser] = React.useState<UserResponseModel>();
    const isAuthenticated = useIsAuthenticated();
    const [showConfirmEmailDialog, setShowConfirmEmailDialog] = useState(false);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (isAuthenticated) {
            checkIfUserConfirmedEmail();
        }
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [isAuthenticated]);

    const checkIfUserConfirmedEmail = useCallback(async () => {
        try {         
          

            const client = getUsersClient();
            const userResp = await client.getUserDetails(undefined);
            setUser(userResp);

            let expiryDate = addMinutes(userResp.createdAtUtc, 30 );

            props.onConfirmEmailStatusChange(!!userResp.confirmedEmailAtUtc, expiryDate);

            if (!userResp.confirmedEmailAtUtc && userResp.createdAtUtc > new Date("2021-07-01")) {
                const thirtyMinutes = 30 * 60 * 1000;
                const dateNowUtc = new Date();
                const timePassedAfterRegistration = dateNowUtc.getTime() - userResp.createdAtUtc.getTime();               
                if (timePassedAfterRegistration > thirtyMinutes) {
                    setShowConfirmEmailDialog(true);
                    startInterval();
                } else {
                    setTimeout(checkIfUserConfirmedEmail, thirtyMinutes - timePassedAfterRegistration);
                }
            } else {
                setShowConfirmEmailDialog(false);
                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                    intervalRef.current = null;
                }
            }
        } catch (error) {
            processServerError(error, undefined, "An error occurred while getting user details.");
            clearInterval(intervalRef.current);
        }
    }, []);

    const startInterval = useCallback(() => {
        if (intervalRef.current) return;

        intervalRef.current = setInterval(() => {
            checkIfUserConfirmedEmail();
        }, 3000);
    }, [checkIfUserConfirmedEmail]);

    return (
        <div>
            {showConfirmEmailDialog && user && <ConfirmEmailDialog isOpened user={user} />}
        </div>
    );
};
